export const HANDSHAKE_URL: string =
  'https://payments.bankalfalah.com/HS/HS/HS';
export const SANDBOX_HANDSHAKE_URL: string =
  'https://sandbox.bankalfalah.com/HS/HS/HS';
export const POST_URL: string = 'https://payments.bankalfalah.com/SSO/SSO/SSO';
export const SANDBOX_POST_URL: string =
  'https://sandbox.bankalfalah.com/SSO/SSO/SSO';
